import { useIntl } from 'react-intl';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { StyledConfirmationPageWrapper } from './style';
import { Icon } from 'ui';
import PublicRoute from 'enums/publicRoutes';

export const ConfirmationPage = () => {
  const intl = useIntl();
  let [searchParams] = useSearchParams();
  const email = searchParams.get('email');
  const navigate = useNavigate();

  return (
    <StyledConfirmationPageWrapper>
      <div className={'content'}>
        <div className="content_inner">
          <div className={'close-button-wrapper'}>
            <Icon name={'global-close-icon'} onClick={() => navigate(PublicRoute.HOME)} />
          </div>
          <div className={'confirmation-content'}>
            <div className="box">
              <h2 className={'title'}>
                {intl.formatMessage({ id: 'confirmation.title' })}
              </h2>
              <p className="text">
                {intl.formatMessage({ id: 'confirmation.text' })}
              </p>
              <b className="email">{email}</b>
              <img className="img" src="confirmation-email.png" alt="email" />
            </div>
          </div>
        </div>
      </div>
    </StyledConfirmationPageWrapper>
  );
};
